"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Disclaimer = void 0;
const forms_v2_1 = require("@kyruus/forms-v2");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
/**
 * Disclaimer component.
 *
 * This component renders the disclaimer content.
 *
 * @param {Object} props - The props object.
 * @param {string|Array<string>} props.disclaimer - The disclaimer content, which can be a string, an array of strings, or an array of objects.
 * @param {Function} props.handleTrack - The function to track events.
 *
 * @returns {JSX.Element} The rendered disclaimer content.
 */
const Disclaimer = ({ disclaimer, handleTrack }) => {
    if (typeof disclaimer === 'string') {
        return react_1.default.createElement("p", null, disclaimer);
    }
    /* footer disclaimer can be configured the same as a form field "add on"
          which supports a modal link */
    if (disclaimer.some((disc) => disc.sentence)) {
        return (react_1.default.createElement(forms_v2_1.AddOn, { onTrack: handleTrack, addOnType: "disclaimer", content: disclaimer }));
    }
    return disclaimer.map((paragraph) => react_1.default.createElement("p", { key: paragraph }, paragraph));
};
exports.Disclaimer = Disclaimer;
exports.Disclaimer.propTypes = {
    disclaimer: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.arrayOf(prop_types_1.default.string),
        prop_types_1.default.shape({
            sentence: prop_types_1.default.string,
            hasModal: prop_types_1.default.bool,
            modalContent: prop_types_1.default.shape({
                title: prop_types_1.default.string,
                body: prop_types_1.default.arrayOf(prop_types_1.default.string)
            })
        })
    ]),
    handleTrack: prop_types_1.default.func
};
//# sourceMappingURL=Disclaimer.js.map